  import { Injectable } from '@angular/core';
  import { BehaviorSubject, Subject } from 'rxjs';

  @Injectable({
    providedIn: 'root'
  })
  export class GlobalService {
    openSignInModal = new BehaviorSubject<boolean>(false);
    openDemoModal = new BehaviorSubject <boolean>(false);
    openSignupModal = new BehaviorSubject <boolean>(false);
    menuIndex = new BehaviorSubject<number>(0);

    openSignUpModal = new BehaviorSubject<boolean>(false);

    searchCondition = new Subject<number>();
    reinitialize = new BehaviorSubject<boolean>(false);
    totalRecordsCount = new BehaviorSubject<number>(0);
    searchQuery = new BehaviorSubject<string>("");
    searchFilters = new BehaviorSubject<any>({});
    isComeFromFilter = new BehaviorSubject<boolean>(false);
    backToResult = new BehaviorSubject<boolean>(false);
    constructor() { }

    sendOpenSignInModal(data: any) {
      this.openSignInModal.next(data);
    }
    sendOpenSignUpModal(data: any) {
      this.openSignupModal.next(data);
    }

    getOpenSignInModal() {
      return this.openSignInModal.asObservable();
    }
    getOpenSignUpModal() {
      return this.openSignupModal.asObservable();
    }
    getOpenDemoModel() {
      return this.openDemoModal.asObservable();

    }
    sendMenuIndex(data: any) {
      this.menuIndex.next(data);
    }

    getMenuIndex() {
      return this.menuIndex.asObservable();
    }
    sendSearchCondition(data: any) {
      this.searchCondition.next(data);
    }
  
    getSearchCondition() {
      return this.searchCondition.asObservable();
    }


    //////////////////// For Email Search ////////////////////
    private searchByEmail_Data = new BehaviorSubject<any>(null);
    
    setSearchByEmail_Data(data:any){
      this.searchByEmail_Data.next(data);
    }
    getSearchByEmail_Data(){
      return this.searchByEmail_Data.asObservable();
    } 
  }
